import { Contact } from './../../../my-account/interfaces/company-settings.interface';
import { fuelType } from './../../../../core/constants/FuelType';
import { chassisType } from './../../../../core/constants/ChassisType';
import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { ActiveRoutesService } from 'src/app/pages/active-routes/services/active-routes.service';
import { AddressLatLng } from 'src/app/shared/address-input/address-input.component';
import { MyServicesService } from '../../services/my-services.service';
import { EditServiceService, FORM_KEYS } from './edit-service.service';
import { ActiveRoutesDetail, Order, OrderPayload, Product, ToppingServiceData } from 'src/app/pages/active-routes/components/active-routes-detail/interfaces/ActiveRoutesDetail.interface';
import { FunnelService } from 'src/app/pages/new-service/services/funnel.service';
import { ProductCatalogParams, ToppingCatalogParams } from 'src/app/pages/new-service/services/interfaces/funnel.interface';
import { MappedProduct, MappedTopping, ServerProduct, ServerTopping } from 'src/app/pages/new-service/interfaces/Topping';
import { myToppingDictionary, ToppingIds } from 'src/app/pages/new-service/constants/ToppingDictionary';
import { TranslateService } from '@ngx-translate/core';
import { VehicleRouteInfoStepComponent } from './components/vehicle-route-info-step/vehicle-route-info-step.component';
import { ServiceConfiguration } from 'src/app/pages/new-service/interfaces/SummaryData';
import * as momentTz from 'moment-timezone';
import { CategoryId, productEndpointByCategoryId } from 'src/app/shared/billing-summary/billing-summary.component';


interface NavbarStep {
  Title: string;
  Id: number;
  Active?: boolean;
  Completed?: boolean;
}

enum Step {
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
  Step4 = 4,
}


@Component({
  selector: 'app-edit-service-modal',
  templateUrl: './edit-service-modal.component.html',
  styleUrls: ['./edit-service-modal.component.scss']
})
export class EditServiceModalComponent {

  onClose = new BehaviorSubject<boolean | undefined>(false);
  OrderHash: string | undefined;
  NewOrderHash: string | undefined;
  loading: boolean = false;
  ServiceForm: FormGroup = new FormGroup({});
  CurrentStep: Step = 1;
  Step = Step;
  skeletonLoaders = Array(4);
  ServiceDetails!: ActiveRoutesDetail;
  Toppings: MappedTopping[] = [];
  FORM_KEYS = FORM_KEYS;
  LoadingRoutes: boolean = false;
  LoadingSimulation: boolean = false;
  ErrorSimulation: boolean = false;
  LoadingSave: boolean = false;

  @ViewChild('VehicleRouteComponent')
  VehicleRouteComponent!: VehicleRouteInfoStepComponent;


  constructor(public bsModalRef: BsModalRef, private ActiveRoutesService: ActiveRoutesService, private EditServiceService: EditServiceService, private FunnelService: FunnelService, private TranslateService: TranslateService) { }

  ngOnInit() {
    this.getServiceDetails()
  }

  setForm() {
    this.ServiceForm = this.EditServiceService.createServiceForm(this.ServiceDetails)
  }

  get addressDataFormGroup(): FormGroup {
    return this.ServiceForm.get(FORM_KEYS.AddressData) as FormGroup;
  }

  get dayContactDataFormGroup(): FormGroup {
    return this.ServiceForm.get(FORM_KEYS.DayContactData) as FormGroup;
  }

  get PrincipalProduct(): AbstractControl<any, any> {
    const productsArray = this.ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
    return productsArray?.at(0)
  }

  get PrincipalProductId(): string {
    const productsArray = this.ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
    return productsArray?.at(0)?.get('ProductId')?.value;
  }

  get PrincipalProductVerticalType(): CategoryId {
    const productsArray = this.ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
    return productsArray?.at(0)?.get('ProductType')?.value;
  }

  get PrincipalProductKey(): string {
    const productsArray = this.ServiceForm.get([FORM_KEYS.ProductData, FORM_KEYS.Products]) as FormArray;
    return productsArray?.at(0)?.get('ProductKey')?.value;
  }



  get isAddressDataStepValid(): boolean {
    const group = this.ServiceForm?.get(FORM_KEYS.AddressData) as FormGroup;
    return group?.valid ?? false;
  }

  get isContactDataStepValid(): boolean {
    const group = this.ServiceForm?.get(FORM_KEYS.DayContactData) as FormGroup;
    return group?.valid ?? false;
  }


  navbarSteps = [
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.5'), Id: 1 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.6'), Id: 2 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.7'), Id: 3 },
    { Title: this.TranslateService.instant('EDIT_SERVICES.HEADER.8'), Id: 4 },
  ].map(step => ({
    ...step,
    Active: step.Id === this.CurrentStep,
    Completed: step.Id < this.CurrentStep,
  }));

  updateNavbarSteps() {
    this.navbarSteps = this.navbarSteps.map(step => ({
      ...step,
      Active: step.Id === this.CurrentStep,
      Completed: step.Id < this.CurrentStep,
    }));
  }


  async getServiceDetails() {
    this.loading = true;

    this.ActiveRoutesService.activeRoutesDetails(this.OrderHash!).subscribe(async (res: ActiveRoutesDetail) => {
      this.ServiceDetails = this.normalizeServiceDetails(res);

      this.setForm();
      await this.getToppingsAvailable(this.ServiceDetails);
      this.loading = false;
    });
  }

  private normalizeServiceDetails(res: ActiveRoutesDetail): ActiveRoutesDetail {
    if (res.BillingAddress && !res.BillingAddress.DisplayName && 'Name' in res.BillingAddress) {
      res.BillingAddress.DisplayName = (res.BillingAddress as any)['Name'];
    }
    return res;
  }

  async getToppingsAvailable(ServiceDetails: ActiveRoutesDetail): Promise<void> {
    let params: ToppingCatalogParams = {
      originLatitude: ServiceDetails?.OriginLatitude,
      originLongitude: ServiceDetails?.OriginLongitude,
      destinationLatitude: ServiceDetails?.DestinationLatitude,
      destinationLongitude: ServiceDetails?.DestinationLongitude,
      fuelType: ServiceDetails?.VehicleInformation?.FuelType,
      chassisType: ServiceDetails?.VehicleInformation?.ChassisType,
      verticalType: this.PrincipalProductVerticalType
    };

    try {
      const response = await this.FunnelService.getToppingCatalog(params).toPromise() as { Categories: any[] };

      if (response && Array.isArray(response.Categories)) {
        this.Toppings = this.mapToppings(response);
        this.Toppings = this.filterToppings(this.Toppings)
      } else {
        console.warn('No se encontraron categorías válidas en la respuesta.');
        this.Toppings = [];
      }

    } catch (error) {
      console.error('Error al obtener toppings:', error);
      this.Toppings = [];
    }
  }

  ToppingsToRemove: string[] = ['topping-vehicle-storage']

  filterToppings(toppings: MappedTopping[]): MappedTopping[] {
    return toppings.filter((x: MappedTopping) => {
      return !this.ToppingsToRemove.includes(x.title)
    })
  }


  mapToppings(serverResponse: { Categories: ServerTopping[]; }): MappedTopping[] {
    return serverResponse?.Categories?.map((category) => {
      const dictionaryInfo = myToppingDictionary[category.Title] || {};

      return {
        ...dictionaryInfo,
        title: category.Title,
        sortOrder: category.SortOrder,
        hideInfoIcon: false,
        products: this.mapProductsWithRelated(category.Products, dictionaryInfo),
      };
    });
  }

  private mapProductsWithRelated(products: ServerProduct[], dictionaryInfo: any): MappedProduct[] {
    return products.map((product) => {
      const productDictionaryInfo = dictionaryInfo.relatedToppings?.[product.ProductKey] || {};

      const mappedProduct: MappedProduct = {
        Id: product.Id || productDictionaryInfo.id || '',
        id: product.Id || productDictionaryInfo.id || '',
        productKey: product.ProductKey,
        price: product.Price,
        priceTaxes: product.PriceTaxes,
        isBundle: product.IsBundle,
        verticalType: product.VerticalType,
        caflerFee: product.CaflerFee,
        caflerFeeTaxes: product.CaflerFeeTaxes,
        icon: productDictionaryInfo.icon || dictionaryInfo.icon,
        titleId: productDictionaryInfo.titleId || dictionaryInfo.titleId,
        descriptionId: productDictionaryInfo.descriptionId || dictionaryInfo.descriptionId,
        showStartingFrom: productDictionaryInfo.showStartingFrom ?? dictionaryInfo.showStartingFrom,
        relatedProducts: [],
      };

      if (product.IsBundle && product.RelatedProducts) {
        mappedProduct.relatedProducts = this.mapRelatedProducts(
          product.RelatedProducts,
          productDictionaryInfo.relatedToppings || {}
        );
      }

      return mappedProduct;
    });
  }

  private mapRelatedProducts(
    relatedProducts: ServerProduct[],
    relatedToppingsDictionary: any
  ): MappedProduct[] {
    return relatedProducts.map((relatedProduct) => {
      const relatedProductDictionaryInfo =
        relatedToppingsDictionary[relatedProduct.ProductKey] || {};

      return {
        Id: relatedProduct.Id,
        id: relatedProduct.Id,
        productKey: relatedProduct.ProductKey,
        price: relatedProduct.Price,
        priceTaxes: relatedProduct.PriceTaxes,
        isBundle: relatedProduct.IsBundle,
        verticalType: relatedProduct.VerticalType,
        caflerFee: relatedProduct.CaflerFee,
        caflerFeeTaxes: relatedProduct.CaflerFeeTaxes,
        icon: relatedProductDictionaryInfo.icon,
        titleId: relatedProductDictionaryInfo.titleId,
        descriptionId: relatedProductDictionaryInfo.descriptionId,
        showStartingFrom: relatedProductDictionaryInfo.showStartingFrom,
        relatedProducts: [],
      };
    });
  }



  closeModal(reloadPage?: boolean) {
    this.onClose.next(reloadPage);
    this.bsModalRef.hide();
  }

  // Navigation



  backStep() {
    if (!this.LoadingRoutes && !this.LoadingSave && !this.LoadingSimulation) {
      this.CurrentStep--;
      this.updateNavbarSteps();
    }

  }

  async setStep(step: Step) {
    if (!this.LoadingRoutes && !this.LoadingSave && !this.LoadingSimulation) {
      if (step >= Step.Step1) {

        if (step < this.CurrentStep) {
          this.CurrentStep = step;
          this.updateNavbarSteps();
        }

        if (step == Step.Step4) {
          step = this.getCurentStepError();
        }
        if ((this.CurrentStep === Step.Step1 && this.isAddressDataStepValid) ||
          (this.CurrentStep === Step.Step2) ||
          (this.CurrentStep === Step.Step3 && this.isContactDataStepValid) ||
          (this.CurrentStep === Step.Step4 && this.ServiceForm.valid)
        ) {
          if (this.CurrentStep === Step.Step1) {
            this.LoadingRoutes = true;
            const canContinue = await this.checkProductByDirecction();
            if (!canContinue) {
              this.LoadingRoutes = false;
              return;
            }
            this.LoadingRoutes = false;
          }

          if (this.CurrentStep == Step.Step3) {
            this.simulateService();
          }

          if (this.CurrentStep == Step.Step4) {
            this.saveService();
            return
          }

          this.CurrentStep = step;
          this.updateNavbarSteps();
        }
      }
    }
  }

  getCurentStepError(): Step {
    if (!this.isAddressDataStepValid) {
      return Step.Step1;
    }
    if (!this.isContactDataStepValid) {
      return Step.Step3;
    }
    return Step.Step4;
  }


  OrderPayload!: OrderPayload;



  SetOrderPayload(details: ActiveRoutesDetail): OrderPayload {
    let Toppings: ToppingServiceData[] = this.getToppingsConfiguration(details)
    let OrderPayload: OrderPayload = {
      OrderHash: this.OrderHash,
      Order: this.getOrderDataByDetails(details),
      Toppings: Toppings
    }
    return OrderPayload;
  }

  getOrderDataByDetails(details: ActiveRoutesDetail): Order {
    return {
      ZoneId: details.StartZoneId,
      FinishZoneId: details.EndZoneId,
      ProductId: this.PrincipalProductId,
      ServiceStartDate: this.getDateFormatedZone(details.StartDate!), // ISO 8601 format with timezone
      ServiceEndDate: this.getDateFormatedZone(details.EndDate!),   // ISO 8601 format with timezone
      Comments: details.Comments,
      OriginContactName: details.OriginContactName,
      OriginContactPhoneNumber: details.OriginContactPhoneNumber,
      OriginContactEmailAddress: details.OriginContactEmail ? "alan.heredero@cafler.com" : details.OriginContactEmail,
      IsOriginContactExternal: details.IsOriginContactExternal,
      OriginAddress: details.OriginAddress,
      OriginAddressDetails: details.OriginAddressDetails,
      OriginAddressLatitude: details.OriginLatitude,
      OriginAddressLongitude: details.OriginLongitude,
      DestinationContactName: details.DestinationContactName,
      DestinationContactPhoneNumber: details.DestinationContactPhoneNumber,
      DestinationContactEmailAddress: details.DestinationContactEmail == "" ? "alan.heredero@cafler.com" : details.DestinationContactEmail,
      IsDestinationContactExternal: details.IsDestinationContactExternal,
      DestinationAddress: details.DestinationAddress,
      DestinationAddressDetails: details.DestinationAddressDetails,
      DestinationAddressLatitude: details.DestinationLatitude,
      DestinationAddressLongitude: details.DestinationLongitude,
      VehicleChassisType: this.ServiceDetails.VehicleInformation?.ChassisType,
      VehicleFuelType: this.ServiceDetails.VehicleInformation?.FuelType,
      LicensePlate: [this.ServiceDetails.VehicleInformation?.LicensePlate],
      VehicleBrand: this.ServiceDetails.VehicleInformation?.Brand,
      VehicleModel: this.ServiceDetails.VehicleInformation?.Model,
      ServiceConfiguration: this.getServiceConfigurationByProduct(this.PrincipalProduct as Product) === "" ? {} : this.getServiceConfigurationByProduct(this.PrincipalProduct as Product),
      RequiresTechnicalInspection: false,
      Tags: details.Tags,
      CustomFields: details.CustomFields
    }
  }

  getDateFormatedZone(date: string): string {
    const timezone = momentTz.tz.guess();
    const parsedDate = momentTz.tz(date, 'DD-MM-YYYY HH:mm', timezone);
    return parsedDate.format('YYYY-MM-DDTHH:mm:ssZ') + ' ' + timezone;
  }

  getServiceConfigurationByProduct(product: Product): string | null {
    let ServiceConfiguration: string | any | null = ""


    switch (product.ProductKey) {
      case "refueling-topping":
        ServiceConfiguration = JSON.stringify({
          MonetaryAmount: product.Amount,
          FuelType: this.ServiceDetails.VehicleInformation?.FuelType
        })
        break;

      default:
        ServiceConfiguration = "";
    }


    return ServiceConfiguration;
  }

  getToppingsConfiguration(details: ActiveRoutesDetail): ToppingServiceData[] {
    if (details.FinancialInformation?.Products) {
      let ToppingServiceData: ToppingServiceData[] = details.FinancialInformation.Products.map((product: Product): ToppingServiceData => {
        return {
          ProductId: product.ProductId!,
          ServiceConfiguration: this.getServiceConfigurationByProduct(product)
        }
      })
      return ToppingServiceData.slice(1);
    }
    return [];

  }


  simulateService() {
    this.LoadingSimulation = true;
    this.ErrorSimulation = false;
    let ServiceDetails = this.EditServiceService.getServiceDetailsByForm(this.ServiceForm, this.ServiceDetails);
    this.OrderPayload = this.SetOrderPayload(ServiceDetails);
    this.EditServiceService.simulationEdit(this.OrderPayload, productEndpointByCategoryId[this.PrincipalProductVerticalType]).subscribe((data: any) => {

      this.ServiceForm.setControl(
        FORM_KEYS.ProductData,
        this.EditServiceService.updateProductDataGroup(
          this.ServiceDetails,
          data.TotalOrderAmount,
          data.TotalOrderTaxAmount,
          data.Products,
          data.Fees
        )
      );

      this.LoadingSimulation = false;
      this.OrderHash = this.OrderPayload.OrderHash;
      this.NewOrderHash = data.OrderHash;
    },
      (error) => {
        console.error(error.error)
        this.ErrorSimulation = true;
        this.CurrentStep = Step.Step3;
        this.updateNavbarSteps();
        this.LoadingSimulation = false;

      }
    )
  }

  saveService() {
    this.LoadingSave = true;
    this.EditServiceService.saveEdit(this.OrderHash, this.NewOrderHash)?.subscribe((data) => {
      this.LoadingSave = false;
      this.closeModal(true)
    })
  }

  updateProductTypeByProduct(Products: Product[]): number[] {
    return Products
      .map(x => x.ProductType)
      .filter((x): x is number => typeof x === 'number');
  }


  async checkProductByDirecction(): Promise<boolean> {
    if (this.VehicleRouteComponent?.ShowProductErrorMessage) { return false; }
    if (this.EditServiceService.hasAddressDataChanged(this.addressDataFormGroup)) {
      const exists = await this.checkIsSamePrincipalProduct();
      return exists;
    }
    return true;
  }

  checkIsSamePrincipalProduct(): Promise<boolean> {
    const params = {
      originLatitude: this.addressDataFormGroup.get([FORM_KEYS.OriginAddress, FORM_KEYS.Lat])?.value,
      originLongitude: this.addressDataFormGroup.get([FORM_KEYS.OriginAddress, FORM_KEYS.Lng])?.value,
      destinationLatitude: this.addressDataFormGroup.get([FORM_KEYS.DestinationAddress, FORM_KEYS.Lat])?.value,
      destinationLongitude: this.addressDataFormGroup.get([FORM_KEYS.DestinationAddress, FORM_KEYS.Lng])?.value,
      chassisType: this.ServiceDetails.VehicleInformation?.ChassisType,
      fuelType: this.ServiceDetails.VehicleInformation?.FuelType,
    };

    return new Promise((resolve) => {
      this.FunnelService.getProductCatalog(params).subscribe(
        (data) => {
          const exists = data?.Categories?.some(category =>
            category.Products?.some(product => product.Id === this.PrincipalProductId)
          );

          if (exists) {
            this.VehicleRouteComponent?.showProductError(false)
            this.EditServiceService.updateInitialAddresValues(this.addressDataFormGroup)
            this.ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.OriginAddress])?.patchValue({
              [FORM_KEYS.ZoneId]: data.ZoneId
            });
            this.ServiceForm.get([FORM_KEYS.AddressData, FORM_KEYS.DestinationAddress])?.patchValue({
              [FORM_KEYS.ZoneId]: data.FinishZoneId
            });
            resolve(true);
          } else {
            this.VehicleRouteComponent?.showProductError(true)

            resolve(false);
          }
        },
        (error) => {
          this.VehicleRouteComponent?.showProductError(true)
          resolve(false);
        }
      );
    });
  }

  updateServiceDetails(event: ActiveRoutesDetail) {
    this.ServiceDetails.CustomFields = event.CustomFields;

  }


}
